import { registerPasskey, supported } from '../webauthn/passkeys';

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('#webauthn-credential-form');
  if (!form) return;

  const button = form.querySelector('[data-webauthn-register]');
  const nicknameField = form.querySelector('[name="nickname"]');
  const errorBox = form.querySelector('[data-webauthn-error]');

  if (!button || !supported()) {
    if (button) button.disabled = true;
    return;
  }

  button.addEventListener('click', event => {
    event.preventDefault();

    if (errorBox) errorBox.textContent = '';
    button.disabled = true;

    registerPasskey({
      optionsUrl: form.dataset.optionsUrl,
      createUrl: form.dataset.createUrl,
      nickname: nicknameField ? nicknameField.value.trim() : ''
    })
      .then(() => {
        globalThis.location.reload();
      })
      .catch(error => {
        if (errorBox) errorBox.textContent = error.message;
        button.disabled = false;
      });
  });
});
